<template>
  <div class="proxyip">
    <banner :swiperData="swiperData" :pagination="false" />
    <div class="main">
      <tabs :tabsList="tabsList" />
      <div
        class="tabs-content width1534"
        :style="{ 'border-color': tabsList[active].color }"
      >
        <ipFamily :active="active" />
      </div>
    </div>
  </div>
</template>

<script>
import banner from "@/components/banner";
import tabs from "@/components/tabs";
import ipFamily from "@/components/ip/index";
export default {
  name: "proxyip",
  components: { banner, tabs, ipFamily },
  data() {
    return {
      swiperData: [
        {
          title: "多贝云静态代理",
          content: "基于运营商一手线路资源",
          descript: ["完全自建节点", "高效稳定纯净", "便捷易用"],
          btn: [
            {
              icon: require("@/assets/images/banner_icon1.png"),
              text: "免费咨询",
            },
            {
              icon: require("@/assets/images/banner_icon2.png"),
              text: "立刻试用",
            },
          ],
          imgUrl: require("@/assets/images/banner1.png"),
          mimgUrl: require("@/assets/images/mbanner2.jpg"),
        },
      ],
      tabsList: [
        {
          color: "#27a7e7",
          title: "产品简介",
          en: "Product Introduction",
          icon: require("@/assets/images/icon5.png"),
          icon_active: require("@/assets/images/icon1.png"),
        },
        {
          color: "#f78834",
          title: "地区购买",
          en: "Regional purchase",
          icon: require("@/assets/images/icon6.png"),
          icon_active: require("@/assets/images/icon2.png"),
        },
        {
          color: "#004cba",
          title: "常见问题",
          en: "frequently asked question",
          icon: require("@/assets/images/icon8.png"),
          icon_active: require("@/assets/images/icon4.png"),
        },
      ],
      active: 0,
    };
  },
  created() {
    this.$bus.$on("tabsEvent", (res) => {
      this.active = res;
    });
  },
};
</script>

<style lang="less" scoped>
.proxyip {
  .main {
    margin: 56px 0 110px;
  }
  .tabs-content {
    border: 9px solid transparent;
  }
}
@media (max-width: 1024px) {
  .proxyip .tabs-content {
    border: 4px solid transparent;
  }
}
</style>
